<template>
  <div class="layout-form-login">
    <div class="layout-form-login-card">
      <CoverImage />
      <h2 class="institution-heading">{{ heading }}</h2>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import CoverImage from "@/components/users/cover-image.vue";
import { CN_HOST } from "@/configs";
import { mapState } from "vuex";
import { autoLink } from "@/helpers/string";

// testcn.com/api/site_brand?brand=brand
export default {
  name: "layout-form-login",
  props: {
    enabledHeader: {
      type: Boolean,
      default: true,
    },
    enabledFooter: {
      type: Boolean,
      default: true,
    },
    enabledBodyHeader: {
      type: Boolean,
      default: true,
    },
    enabledBodyHeaderDescription: {
      type: Boolean,
      default: true,
    },
    termUrl: {
      type: String,
      default: `${CN_HOST}/tos`,
    },
    policyUrl: {
      type: String,
      default: `${CN_HOST}/policy`,
    },
    cnUrl: {
      type: String,
      default: CN_HOST,
    },
  },
  components: {
    CoverImage
  },
  data() {
    return {
      arrowLeft: require("@/assets/img/left_black.png"),
      arrowRight: require("@/assets/img/right_black.png"),
      screenShot: require("@/assets/img/screen_shot.png"),
      cardIndex: 0,
    };
  },
  computed: {
    ...mapState("siteBrand", [
      "links",
      "cover_image_url",
      "logo_attachment_url",
      "homepage_url",
      "heading",
      "signup_setting_hint",
      "count",
    ]),
    headerBg() {
      return {
        backgroundImage: `url(${this.cover_image_url})`,
      };
    },
    userCountTitle() {
      return this.count.users + " users have signed up from this page";
    },
  },
  methods: {
    autoLink: autoLink,
    changCardIndex(number) {
      if (number == 0) {
        if (this.cardIndex <= 0) return;
        this.cardIndex = this.cardIndex - 1;
        this.changePic();
      } else {
        if (this.cardIndex >= this.links.length - 1) return;
        this.cardIndex = this.cardIndex + 1;
        this.changePic();
      }
    },

    changePic() {
      console.log(this.cardIndex, 8888888);
      if (this.cardIndex == 0) {
        this.screenShot = require("@/assets/img/screen_shot.png");
      } else if (this.cardIndex == 1) {
        this.screenShot = require("@/assets/img/screenshot2.png");
      } else {
        this.screenShot = require("@/assets/img/screenshot3.jpg");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.layout-form-login-card {
  padding: rem(40);
}


</style>
